import { createUserWithEmailAndPassword } from 'firebase/auth';
import React, { Component, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import { auth } from '../firebase/firebase-config';
import { toast, Toast, ToastContainer } from 'react-toastify';
import { basePostAPI } from "../authPages/BaseRequester";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


function Register() {
  const [loginPassword, setloginPassword] = useState('')
  const [user, setuser] = useState({})
  const [authUser, loading] = useAuthState(auth)

  const [EmailLogin, setEmailLogin] = useState('')
  const [UserName, setUserName] = useState('')
  const [FirstName, setFirstName] = useState('')
  const [lastName, setlastName] = useState('')
  const [bio, setbio] = useState('')

  const [authenticated, setauthenticated] = useState(localStorage.getItem(localStorage.getItem("authenticated") || false));
  let history = useHistory();

  // const CreateSignnUpUser = (email, username, password) => async{
  //   await basePostAPI();

  //   // username,firstname,lastname,profilePicture,isEmailVerified,termsAndCondition

  // };

  const Signup = async (e) => {

    e.preventDefault();
    try {
      const user = await createUserWithEmailAndPassword(auth, EmailLogin, loginPassword).then(async (userCred) => {
        console.log(userCred, 'new user Admin signedUp');
        try {

          var body = { username: UserName, email: EmailLogin, termsAndCondition: true, firstName: FirstName, lastName: lastName, bio: bio }
          // await auth.currentUser.sendEmailVerification();
          var apiResp = await basePostAPI('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyownAdmin/api/v1/admin/newAdmin', { body })
          console.log(apiResp);
          toast.success('Signup Successfull!.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          })
          history.push("/Login");
        } catch (error) {
          console.log(error);
        }
        // var result = await CreateSignnUpUser()
      })



    } catch (error) {
      console.log(error.message);
      switch (error.code) {
        case "auth/Invalid-email":
        case "auth/user-disabled":
        case "auth/user-not-found":
          toast.warning('This Email is Invalid/User not found.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          })
          break;
        case "auth/wrong-password":
          toast.warning('You have entered an incorrect Email/Password', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          })
          break;
        case "auth/internal-error":
          toast.warning('Please enter correct credentials/internal error.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          })
          break;
        case "auth/too-many-requests":
          toast.warning('Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          })
          break;
        default:
      }

    }

  }




  return (
    <div>
      <div className="d-flex align-items-center auth px-0">
        <div className="row w-100 mx-0">
          <div className="col-lg-4 mx-auto">
            <div className="auth-form-light text-left py-5 px-4 px-sm-5">
              <div className="brand-logo">
                {/* <img src={require("../../assets/images/logo.svg")} alt="logo" /> */}
              </div>
              <h4>Create New Admin User</h4>
              <h6 className="font-weight-light">Signing up is easy. It only takes a few steps</h6>
              <form className="pt-3" onSubmit={Signup}>
                <div className="form-group">
                  <input type="text" className="form-control form-control-lg" id="exampleInputUsername1" placeholder="Username" value={UserName} onChange={(e) => {
                    setUserName(e.target.value);
                  }} />
                </div>
                <div className="form-group">
                  <input type="text" className="form-control form-control-lg" id="exampleInputUsername1" placeholder="First Name" value={FirstName} onChange={(e) => {
                    setFirstName(e.target.value);
                  }} />
                </div>
                <div className="form-group">
                  <input type="text" className="form-control form-control-lg" id="exampleInputUsername1" placeholder="Last Name" value={lastName} onChange={(e) => {
                    setlastName(e.target.value);
                  }} />
                </div>
                <div className="form-group">
                  <textarea type="text" className="form-control form-control-lg" id="exampleInputUsername1" placeholder="bio" value={bio} onChange={(e) => {
                    setbio(e.target.value);
                  }} />
                </div>
                <div className="form-group">
                  <input type="email" className="form-control form-control-lg" id="exampleInputEmail1" placeholder="Email" value={EmailLogin} onChange={(e) => {
                    setEmailLogin(e.target.value);
                  }} />
                </div>
                {/* <div className="form-group">
                    <select className="form-control form-control-lg" id="exampleFormControlSelect2">
                      <option>Country</option>
                      <option>United States of America</option>
                      <option>United Kingdom</option>
                      <option>India</option>
                      <option>Germany</option>
                      <option>Argentina</option>
                    </select>
                  </div> */}
                <div className="form-group">
                  <input type="password" className="form-control form-control-lg" id="exampleInputPassword1" placeholder="Password" value={loginPassword} onChange={(e) => {
                    setloginPassword(e.target.value);
                  }} />
                </div>
                <div className="mb-4">
                  <div className="form-check">
                    <label className="form-check-label text-muted">
                      {/* <input type="checkbox" className="form-check-input" /> */}
                      {/* <i className="input-helper"></i> */}
                      By Signing Up You agree to all Terms & Conditions
                    </label>
                  </div>
                </div>
                <div className="mt-3">
                  <button onSubmit={Signup} className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" >SIGN UP</button>
                </div>
                <div className="text-center mt-4 font-weight-light">
                  Already have an account? <Link to="/user-pages/login" className="text-primary">Login</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default Register
